import React, { useState, useEffect, useContext } from 'react';

import Grid from '@mui/material/Grid';

import CircuitCountSetter from './CircuitCountSetter';
import PreviousLogsListTable from './PreviousLogsListTable';

import ChillerFormSubmitDialog from './ChillerFormSubmitDialog';

import MainAssetSection from './HeaderSection';
import EvaporatorDetailsSection from './EvaporatorDetailsSection';
import CondenserDetailsSection from './CondenserDetailsSection';
import AllCircuitCompressorsSection from './AllCircuitCompressorsSection';
import AdditionalDetailsSection from './AdditionalDetailsSection';
import ManufacturerDetailsSection from './ManufacturerDetailsSection';
import YorkCircuitDetailsSection from './YorkCircuitDetailsSection';
import ClientCommentsSection from './ClientCommentsSection';
import InternalCommentsSection from './InternalCommentsSection';
import PhotosSection from './PhotosSection';
import DataValidationsSection from './DataValidationsSection';

import ChillerLogHeader from './ChillerLogHeader';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

interface ChillerFormSpreadsheetProps {}

const ChillerFormSpreadsheet: React.FC<ChillerFormSpreadsheetProps> = () => {
  const [submissionError, setSubmissionError] = React.useState('');

  const { user } = useContext(AuthenticationContext);
  const { chillerLog, chillerJob } = useContext(ChillerLogsContext);

  const isTechnicianUser = user?.modules?.some(
    (module) => module.value === 'chiller_logs' && parseInt(module.tier) <= 2,
  );

  const [submitting, setSubmitting] = React.useState(false);
  const [validationStatus, setValidationStatus] = useState<'complete' | 'warning'>('complete');

  useEffect(() => {
    const checkErrorCells = () => {
      const errorCells = document.querySelectorAll('.error-cell');
      setValidationStatus(errorCells.length > 0 ? 'warning' : 'complete');
    };
    checkErrorCells();
    const observer = new MutationObserver(() => {
      checkErrorCells();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  let showManufacturerDetailsSection = chillerLog?.manufacturer_details?.length > 1;
  let showYorkCircuitSection = chillerLog?.circuits?.[0]?.york_circuit_details?.length > 1;

  return (
    <Grid container style={{ marginLeft: -30, width: 1400 }}>
      <ChillerFormSubmitDialog />
      <Grid item xs={12} style={{ marginLeft: 0 }}>
        <ChillerLogHeader chillerJob={chillerJob} />
      </Grid>
      <Grid item xs={6} className="no-print" style={{ marginLeft: 30 }}>
        <CircuitCountSetter />
      </Grid>
      <Grid item xs={9} style={{ marginTop: 20 }} className="no-print">
        <PreviousLogsListTable />
      </Grid>
      <MainAssetSection />

      <EvaporatorDetailsSection />
      <CondenserDetailsSection />

      <Grid item xs={12}>
        <AllCircuitCompressorsSection />
      </Grid>

      <Grid item xs={12}>
        <AdditionalDetailsSection />
      </Grid>
      {showManufacturerDetailsSection && (
        <Grid item xs={12}>
          <ManufacturerDetailsSection />
        </Grid>
      )}
      {showYorkCircuitSection && (
        <Grid item xs={12}>
          <YorkCircuitDetailsSection />
        </Grid>
      )}
      <Grid item xs={12}>
        <ClientCommentsSection />
      </Grid>
      <Grid item xs={12}>
        <InternalCommentsSection />
      </Grid>

      <Grid item xs={12} className="no-print">
        <PhotosSection isTechnicianUser={isTechnicianUser} />
      </Grid>

      <Grid item xs={12} className="chiller-log-photo-content">
        <DataValidationsSection validationStatus={validationStatus} />
      </Grid>
      <Grid item xs={12} className="no-print">
        {submissionError.length > 0 && <p style={{ color: 'red' }}>{submissionError}</p>}
      </Grid>
    </Grid>
  );
};

export default ChillerFormSpreadsheet;
